// Reusable toggle switch used across Stale Job / Stale Client / Client Contact.
import React from 'react';

export default function ToggleSwitch({
  checked,
  onChange,
  label,
  variant,        // undefined | 'danger' | 'warning'
  disabled,
  saving,
}) {
  const cls = [
    'rt-toggle',
    variant ? `rt-toggle--${variant}` : '',
    (disabled || saving) ? 'disabled' : '',
  ].filter(Boolean).join(' ');

  return (
    <label className={cls}>
      <input
        type="checkbox"
        checked={!!checked}
        disabled={disabled || saving}
        onChange={e => onChange(e.target.checked)}
      />
      <span className="rt-toggle-slider" />
      {label && <span className="rt-toggle-label">{label}</span>}
      {saving && <span className="rt-toggle-saving">saving…</span>}
    </label>
  );
}
